export function Skeleton() {
  return (
    <div
      className="h-3 w-full animate-pulse bg-gray-400 leading-relaxed"
      data-testid="skeleton"
    />
  );
}
